import { LocationQuery } from 'vue-router';
import { cacheFirstConfig, http } from '../../helpers/http.helper';
import { ApiResource } from './../../models/api-resource.interface';
import { Degree } from './degree.interface';

export class DegreeService {
   async getDegrees(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Degree>>>(`/degrees`, { ...cacheFirstConfig, params: { ...query } });
      return response.data;
   }
}
